import React from 'react';
import { Icon } from '@mdi/react';
import { mdiAccountCircleOutline, mdiHeartCircleOutline, mdiPencilCircleOutline } from '@mdi/js';
import classNames from 'classnames';

export enum Step {
  Who = 'who',
  What = 'what',
  Details = 'details',
}

export interface WhoWhatDetailsProps {
  step: Step;
}

export default function WhoWhatDetails({ step }: WhoWhatDetailsProps) {
  const who = classNames('left-line', { active: step === 'who' });

  const what = classNames('middle-line', { active: step === 'what' });

  const details = classNames('right-line', { active: step === 'details' });

  return (
    <div className="who-what-details">
      <table cellPadding="0" cellSpacing="0">
        <tbody>
          <tr className="text">
            <td>Who</td>
            <td />
            <td>What</td>
            <td />
            <td>Details</td>
          </tr>
          <tr className="icons">
            <td className={who}><Icon path={mdiAccountCircleOutline} size="36px" /></td>
            <td className="middle-line" />
            <td className={what}><Icon path={mdiHeartCircleOutline} size="36px" /></td>
            <td className="middle-line" />
            <td className={details}><Icon path={mdiPencilCircleOutline} size="36px" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
